import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { MatDialog } from '@angular/material/dialog';
import { ContentServiceService } from '../../../content-service.service';
import { FilterModel, Metadata } from 'src/app/common/MasterModel/masterModel';
import { QuoteModel } from './QuoteModel';
import { DialogService } from 'src/app/common/core-services/DialogService';
@Component({
  selector: 'app-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.css']
})
export class ViewQuoteComponent implements OnInit {

  requestpages: any;
  form: FormGroup;
  metaData: any;
  private filterModel: FilterModel;
  quoteData: QuoteModel[];
  @Output() handleTabChange: EventEmitter<any> = new EventEmitter<any>();
  classToggled = false;

  public toggleField() {
   this.classToggled = !this.classToggled;
  }

  displayedColumns: Array<any> = [
    { displayName: 'QUOTE NAME', key: 'quoteText', isSort: true, class: '', width: '70%' },
    { displayName: 'QUOTE BY', key: 'quoteBy', isSort: true, class: '', width: '20%' },
    { displayName: 'Actions', key: 'Actions', class: '', width: '10%' }

  ];
   actionButtons: Array<any> = [
    //{ displayName: 'Details', key: 'Details', class: 'fas fa-eye' },
    { displayName: 'Edit', key: 'edit', class: 'fas fa-edit' },
    { displayName: 'Delete', key: 'delete', class: 'fas fa-trash' },
  ];
  constructor(private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private router: Router,
    private toaster: ToastrService,
    private dialogService: DialogService,
    private contentService: ContentServiceService,
    ) { 

     this.filterModel = new FilterModel();
     this.quoteData = new Array<QuoteModel>();
    }

  ngOnInit(): void {
    this.metaData = new Metadata();
    this.form = this.formBuilder.group({
      searchValue: [''],
     
    });

    this.getQuoteList(this.filterModel, '', '', );
  }
  onPageOrSortChange(changeState?: any) {
    this.setPaginatorModel(changeState.pageNumber, this.filterModel.pageSize, changeState.sort, changeState.order, this.filterModel.searchText);
    this.getQuoteList(this.filterModel, '', '')
  }
  setPaginatorModel(pageNumber: number, pageSize: number, sortColumn: string, sortOrder: string, searchText: string) {
    this.filterModel.pageNumber = pageNumber;
    this.filterModel.pageSize = pageSize;
    this.filterModel.sortOrder = sortOrder;
    this.filterModel.sortColumn = sortColumn;
    this.filterModel.columnName = sortColumn;
    this.filterModel.searchText = searchText;
  }

  getQuoteList(filterModel: any, tags: any, roleIds: any) {
    this.contentService.getQuotedata(filterModel).subscribe((res: any) => {
      if(res.status > 0){
        console.log(res);
        this.quoteData = res.responseData;
        this.metaData = res.meta;
       
      }else{
        this.metaData = new Metadata();
      }
     
    });
  }

  onTableActionClick(actionObj?: any) {
    const id = actionObj.data && actionObj.data.quotesID;
    switch ((actionObj.action || '').toUpperCase()) {
      case 'EDIT':
        //this.editCall(id);
        this.handleTabChange.next({ tab: "Add Quote", id: id});
        break;
      case 'DELETE':
        {
          
          this.dialogService
            .confirm(`Are you sure you want to delete this record?`)
            .subscribe((result: any) => {
              if (result == true) {
                this.deleteQuote(id);
              }
            });
        }
        break;
        case 'DETAILS':
        //this.infoCall(id);
        break;
      default:
        break;
    }
  }
  applyFilter(searchText: string = '') {
    this.setPaginatorModel(1, this.filterModel.pageSize, this.filterModel.sortColumn, this.filterModel.sortOrder, searchText);
    if (searchText.trim() == '' || searchText.trim().length >= 3) {
      this.getQuoteList(this.filterModel, '', '');
    }
  }

  // searching
  onSubmit() {
    this.requestpages = {
      "pageSize": 10,
      "pageNumber": 1,
      "searchValue": this.form.controls.searchValue.value,
      "columnName": "",
      "sortOrder": ""
    }
    console.log(this.requestpages);
    this.getQuoteList(this.requestpages, '', '')
    //this.AdminUserList();
  }
  reset() {
    this.form.reset();
    this.InitialGridCall();
   
    this.getQuoteList(this.requestpages, '', '')
  }

  InitialGridCall() {
    this.requestpages = {
      "pageSize": 10,
      "pageNumber": 1,
      "searchValue": "",
      "columnName": "",
      "sortOrder": ""
    }
  }
  // end

  deleteQuote(id:any){
    this.contentService.DeleteQuote(id).subscribe((res: any) => {
      if(res.status > 0){
        console.log(res);
        this.toaster.success(res.message, 'Success');
        //this.reset();
        this.getQuoteList(this.filterModel, '', '', );
       
      }else{
        this.metaData = new Metadata();
      }
     
    });
  }

  goto(){
    this.handleTabChange.emit({ tab: "Add Quote", id: 0});
  }

}
